import BaseService from "src/packages/BaseService";

export default class CardService extends BaseService {
	static get className() {
		return "card";
	}
};
